import React from 'react';
import { useTranslation } from 'react-i18next';
import SimpleCheckbox from './SimpleCheckbox';

export default function TodoCard({ title, note, url, isCompleted, onToggle }) {
    const { t } = useTranslation();
    return (
        <div
            onClick={() => onToggle()}
            className="card p-4 cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors duration-200"
        >
            <div className="flex items-start gap-3 mb-2">
                <SimpleCheckbox
                    isChecked={isCompleted}
                    onChange={(e) => { e.stopPropagation(); onToggle(e.target.checked); }}
                    size="lg"
                />
                <h4 className={`font-semibold text-gray-900 dark:text-gray-100 transition-all duration-200 ${isCompleted ? 'line-through opacity-50' : ''}`}>
                    {title}
                </h4>
            </div>

            {note && (
                <p className="text-sm text-gray-600 dark:text-gray-400 ml-8">📝 {note}</p>
            )}

            {url && (
                <a
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={(e) => e.stopPropagation()}
                    className="block mt-3 btn-primary text-sm text-center"
                >
                    {t('common.visitLink')}
                </a>
            )}
        </div>
    );
}
